import { styled } from 'styled-components'

import Clickable from 'core/components/lib/Clickable'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  width: 100%;
`

export const Title = styled.h1`
  margin: 0;
  padding-right: 16px;
  font-size: 22px;
`

export const PaddedWrapper = styled.div`
  padding-left: 16px;
`

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
`

export const ActionBarLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

// LeftPanel removed as it was unused

export const StyledBackLink = styled(Clickable)`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 500;

  &:hover {
    text-decoration: none;
  }
`

export const Contents = styled.div`
  box-sizing: border-box;
  width: calc(100% - 2px);
  height: 100%;
`
